/*
 * PokeVault PH — client-side "sort by card number".
 * Shopify storefront sort has no card-number key and smart collections
 * can't be manually ordered. When the shopper picks the card-number option
 * we pull in every page of the current (filtered) collection once, then sort
 * all cards by data-pv-cardnum. Normal browsing keeps the default page size.
 * Re-applies after Dawn's AJAX filter/sort swaps (#ProductGridContainer).
 */
(function () {
  var GRID_ID = 'product-grid';
  var CONTAINER_ID = 'ProductGridContainer';
  var fetching = false;
  var loadedKey = null;

  function currentSort() {
    return new URLSearchParams(window.location.search).get('sort_by');
  }
  function isCardSort(s) {
    return s === 'pv-cardnum-asc' || s === 'pv-cardnum-desc';
  }
  function num(li) {
    var n = parseInt(li.getAttribute('data-pv-cardnum'), 10);
    return isNaN(n) ? 999999 : n;
  }
  function liChildren(grid) {
    return Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.tagName === 'LI';
    });
  }

  function sortInPlace(grid, sort) {
    var items = liChildren(grid);
    if (items.length < 2) return;
    items.sort(function (a, b) {
      return sort === 'pv-cardnum-asc' ? num(a) - num(b) : num(b) - num(a);
    });
    var frag = document.createDocumentFragment();
    items.forEach(function (li) {
      frag.appendChild(li);
    });
    grid.appendChild(frag);
  }

  function maxPage() {
    var max = 1;
    document
      .querySelectorAll('#' + CONTAINER_ID + ' .pagination__list a[href]')
      .forEach(function (a) {
        var m = a.getAttribute('href').match(/[?&]page=(\d+)/);
        if (m) max = Math.max(max, parseInt(m[1], 10));
      });
    return max;
  }

  function fetchAllThenSort(grid, sort, key) {
    var pages = maxPage();
    if (pages < 2) {
      sortInPlace(grid, sort);
      return;
    }
    fetching = true;
    var params = new URLSearchParams(window.location.search);
    var reqs = [];
    for (var p = 2; p <= pages; p++) {
      params.set('page', String(p));
      reqs.push(
        fetch(window.location.pathname + '?' + params.toString())
          .then(function (r) { return r.text(); })
          .catch(function () { return ''; })
      );
    }
    Promise.all(reqs)
      .then(function (htmls) {
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.getElementById(GRID_ID);
          if (!g) return;
          liChildren(g).forEach(function (li) {
            grid.appendChild(li);
          });
        });
        var pag = document.querySelector('#' + CONTAINER_ID + ' .pagination-wrapper');
        if (pag) pag.style.display = 'none';
        loadedKey = key;
      })
      .catch(function () {})
      .then(function () {
        fetching = false;
        sortInPlace(grid, sort);
      });
  }

  function setDefaultsCardnum() {
    var c = document.getElementById(CONTAINER_ID);
    return !!c && c.getAttribute('data-pv-cardnum-default') === 'true';
  }

  function apply() {
    var sort = currentSort();
    // No explicit sort: default to card-number only on set collections.
    if (sort === null) {
      if (!setDefaultsCardnum()) return;
      sort = 'pv-cardnum-asc';
    }
    if (!isCardSort(sort)) return;

    var grid = document.getElementById(GRID_ID);
    if (!grid || fetching) return;

    var select = document.getElementById('SortBy');
    if (select && select.value !== sort) select.value = sort;

    var key = window.location.pathname + window.location.search;
    var hasMorePages =
      !!document.querySelector('#' + CONTAINER_ID + ' .pagination-wrapper');

    if (hasMorePages && loadedKey !== key) {
      fetchAllThenSort(grid, sort, key);
    } else {
      sortInPlace(grid, sort);
    }
  }

  function init() {
    apply();
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    // subtree:false so our own grid reordering doesn't retrigger the observer;
    // Dawn replaces container.innerHTML on filter/sort, which fires childList.
    var timer;
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(apply, 60);
    }).observe(container, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
